var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 26,
    fill: "none",
    viewBox: "0 0 22 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E12121",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.315 18.93C8.451 20.278 7.502 21.24 7 21.4c-1.777.564-3.021-.964 2.315-2.47Zm0 0c.462-.72.9-1.55 1.233-2.426M9.315 18.93c.392-.11.82-.22 1.284-.33.526-.124 1.01-.216 1.452-.28m-1.503-1.816c.522-1.376.784-2.865.472-4.219a.649.649 0 0 0-.065-.168c-.807-1.424-1.91 1.626-.407 4.387Zm0 0a6.18 6.18 0 0 0 1.503 1.815m0 0c.745.616 1.71 1.137 2.949 1.481 1.833.366 1.893-2.189-2.95-1.48ZM12.6 1v6.4A1.6 1.6 0 0 0 14.2 9h6.4m-16 16h12.8a3.2 3.2 0 0 0 3.2-3.2V9.556a2.4 2.4 0 0 0-.658-1.65L14.11 1.749A2.4 2.4 0 0 0 12.368 1H4.6a3.2 3.2 0 0 0-3.2 3.2v17.6A3.2 3.2 0 0 0 4.6 25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.d9614fb862c2b9ea0ad52d39fdd8ada7.svg";
export { ForwardRef as ReactComponent };